/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC, useRef } from "react";
import { FC_ANCHOR } from "../FloatingContainer";
import { Icon, ICON_SIZE } from "../Icon";
import { Tooltip } from "../Tooltip";
import { IFieldValidationError } from "./FieldTypes";

export interface IFieldValidationErrorsProps {
	errors?: IFieldValidationError[];
}

export const FieldValidationErrors: FC<IFieldValidationErrorsProps> = ({ errors }) => {
	const iconElRef = useRef<HTMLSpanElement>();

	const baseClass = BEM("edt-field");

	if (Array.isArray(errors) && errors.length > 0) {
		return (
			<>
				<span className={baseClass.element("error-icon").toClassName()} ref={iconElRef}>
					<Icon name="mdi/alert" size={ICON_SIZE.XSMALL} />
				</span>
				<Tooltip
					for={iconElRef}
					anchor={FC_ANCHOR.CENTER_TOP}
					openDelay={1}
					className={baseClass.element("validation-errors-tooltip").toClassName()}
				>
					<ul className={baseClass.element("validation-errors").toClassName()}>
						{errors.map((item, index) => {
							return (
								<li key={index}>
									<span
										className={baseClass
											.element("validation-errors-message")
											.toClassName()}
									>
										{item.message}
									</span>
									{item.details && item.details.length > 0 ? (
										<ul
											className={baseClass
												.element("validation-errors-details")
												.toClassName()}
										>
											{item.details.map((detailItem) => (
												<li key={detailItem}>{detailItem}</li>
											))}
										</ul>
									) : null}
								</li>
							);
						})}
					</ul>
				</Tooltip>
			</>
		);
	} else {
		return null;
	}
};
